<template>
  <v-layout row wrap>
    <v-flex xs12 class="pt-0">
      <v-data-table
        :headers="headers"
        :items="listItems"
        :total-items="totalItems"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="ch-table-list"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text"
              class="text-xs-left"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon v-if="sortableList.includes(header.value)">arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.doorlock.name }}</span><pre>{{ props.item.doorlock.name }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.log_id }}</span><pre>{{ props.item.log_id }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="20%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.log_type }}</span><pre>{{ props.item.log_type }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="40%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.log_message }}</span><pre>{{ props.item.log_message }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.log_event_date }}</span><pre>{{ props.item.log_event_date }}</pre></v-tooltip></td>
          <td class="text-xs-left" width="10%"><v-tooltip bottom color="primary" ><span slot="activator">{{ props.item.created_at }}</span><pre>{{ props.item.created_at }}</pre></v-tooltip></td>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import { doorlocksLogsEventBus } from '@/components/admin/doorlocks/doorlocksLogsEventBus';
  import logFormatter from '@/components/admin/doorlocks/doorlockLogFormatter';
  import api from '../../../api';

  export default {
    data() {
      return {
        id: null,
        hotel_id: null,
        // NOTE: Table List
        // TODO: loading: true 테이블의 아이템이 교체가 완료된 후 false로 변경(페이지 로딩, 다른 페이지로 이동, 검색,...)
        loading: false,
        pagination: {
          sortBy: 'log_id',
          descending: true,
          rowsPerPage: 20,
        },
        totalItems: 0,
        searchCategory: null,
        search: null,
        headers: [
          { text: 'Name', value: 'name', align: 'left', sortable: false },
          { text: 'Log ID', value: 'log_id', align: 'left' },
          { text: 'Log Type', value: 'log_type', align: 'left', sortable: false },
          { text: 'Log Message', value: 'log_message', align: 'left', sortable: false },
          { text: 'Log Event Date', value: 'log_event_date', align: 'left' },
          { text: 'Created At', value: 'created_at', align: 'left' },
        ],
        rowsPerPageItems: [20, 50],
        sortableList: ['log_id', 'log_event_date', 'created_at'],
        // NOTE: Data
        listItems: [],
        filter: [],       // 쿼리문을 담을 배열
      };
    },
    methods: {
      // TODO: Api 연결 필요
      getDoorlockLogList() {
        this.loading = true;
        const id = {
          id: this.id,
          hotel_id: this.hotel_id,
        };
        const sortStr = this.pagination.sortBy;
        let orderStr = null;
        let search = null;                        // null & ''이 아닌 필터값을 담을 변수

        if (this.pagination.descending === null) {
          orderStr = null;
        } else if (this.pagination.descending === false) {
          orderStr = 'asc';
        } else if (this.pagination.descending === true) {
          orderStr = 'desc';
        }
        const querystring = {
          sort: sortStr,
          order: orderStr,
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          limit: this.pagination.rowsPerPage,
          pagination: true,
          doorlock_id: this.id,
        };

        /**
         * @description filter의 각 항목을 반복하면서 search속성이 null이나 공백이 아닌 속성만 전달
         */
        function filterBySearch(obj) {
          if ('search' in obj && obj.search !== null && obj.search !== '') {
            return true;
          }
          return false;
        }

        // filter링 된 값들에 대해서만 동작해야한다.
        search = this.filter.filter(filterBySearch);

        for (let index = 0; index < search.length; index += 1) {
          querystring[search[index].searchCategory] = search[index].search;
        }

        api.getDoorlockLogList(id, querystring)
        .then((result) => {
          if (result.status === 200) {
            this.totalItems = result.data.total;
            this.listItems = _.map(result.data.items, (value) => {
              let data = {};
              data = value;
              data.log_message = this.formatMessage(data.log_type, data.log_message);
              data.log_type = this.formatType(data.log_type);
              data.log_event_date = this.formatTime(data.log_event_date);
              data.created_at = this.formatTime(data.created_at);
              return data;
            });
            this.loading = false;
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          this.loading = false;
        });
      },
      formatType(type) {
        return logFormatter.formatType(type);
      },
      formatMessage(type, message) {
        return logFormatter.formatMessage(type, message);
      },
      formatTime(type, message) {
        return logFormatter.formatTime(type, message);
      },
      /**
       * @description 오름차순/내림차순 정렬
       */
      changeSort(column) {
        if (this.sortableList.includes(column)) {
          if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
          } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
          }
        }
      },
    },
    watch: {
      pagination: {
        deep: true,
        handler() {
          this.getDoorlockLogList();
        },
      },
    },
    computed: {
      pages() {
        /* eslint max-len: ["error", { "code": 200 }] */
        return this.pagination.rowsPerPage ? Math.ceil(this.listItems.length / this.pagination.rowsPerPage) : 0;
      },
    },
    mounted() {
      this.id = this.$route.params.id;
      this.hotel_id = this.$route.params.hotel_id;
      this.getDoorlockLogList();
      // NOTE: 필터링 이벤트 청취
      doorlocksLogsEventBus.$on('customFilter', (obj) => {
        this.filter = Object.values(obj);
        this.getDoorlockLogList();
      });
      // NOTE: list reload
      doorlocksLogsEventBus.$on('reloadList', () => {
        this.getDoorlockLogList();
      });
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/doorlocks/DoorlockLogsList.vue